import { Phone, Mail, ExternalLink, MessageCircleMore } from "lucide-react";

export default function Contact() {
  return (
    <section id="contact" className="py-12 sm:py-16 bg-white">
      <div className="container-max">
        <div className="card p-6 sm:p-8">
          <div className="md:flex items-start justify-between gap-6 lg:gap-8">
            <div className="flex-1">
              <div className="text-sm font-semibold text-[color:var(--brand-orange)] uppercase tracking-wider">PRUSHA CORE SOLUTION</div>
              <h3 className="text-2xl sm:text-3xl font-extrabold mt-1">PRUSHA TECHNOLOGY PVT LTD</h3>
              <p className="mt-1 text-brand-blue/80 text-sm sm:text-base">
                Dakor, Gujarat — Reliable broadband for homes, students, and small businesses.
              </p>

              <div className="mt-6 space-y-3 text-sm">
                <a href="https://forms.gle/yXmWRrAEyPhHsuUq9" target="_blank" rel="noopener noreferrer" className="btn btn-primary w-full md:w-auto inline-flex gap-2 justify-center">
                  Fill Connection Form <ExternalLink size={16} className="flex-shrink-0" />
                </a>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <a href="tel:+919712877584" className="btn btn-outline gap-2 justify-center">
                    <Phone size={16} className="flex-shrink-0" />
                    <span className="text-center text-xs sm:text-sm">Call for Service</span>
                  </a>
                  <a href="tel:+919712877584" className="btn btn-outline gap-2 justify-center">
                    <Phone size={16} className="flex-shrink-0" />
                    <span className="text-center text-xs sm:text-sm">New Connection</span>
                  </a>
                </div>
                <div className="bg-brand-blue/5 rounded-lg p-3 text-center">
                  <div className="text-xs text-brand-blue/60 mb-1">Direct Helpline</div>
                  <a href="tel:+919712877584" className="text-lg font-bold text-brand-blue hover:text-brand-orange transition-colors">
                    +91 97128 77584
                  </a>
                </div>
                <a href="mailto:prushatechnology@gmail.com" className="btn btn-outline gap-2 justify-center">
                  <Mail size={16} className="flex-shrink-0" /> Send Email
                </a>
              </div>
            </div>

            <div className="mt-6 md:mt-0 text-center md:text-left">
              <a
                href="https://wa.me/919712877584"
                className="inline-flex items-center gap-2 rounded-full bg-green-500 text-white px-5 py-3 shadow-card hover:bg-green-600 transition-colors active:scale-95"
              >
                <MessageCircleMore size={18} className="flex-shrink-0" />
                <span>WhatsApp: +91 97128 77584</span>
              </a>
              <a
                href="https://wa.me/918155977584"
                className="inline-flex items-center gap-2 rounded-full bg-green-600 text-white px-5 py-3 shadow-card hover:bg-green-700 transition-colors active:scale-95 mt-3"
              >
                <MessageCircleMore size={18} className="flex-shrink-0" />
                <span>WhatsApp: +91 81559 77584</span>
              </a>
              <div className="text-xs text-brand-blue/60 mt-2">We respond quickly on both numbers.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

